export default __webpack_public_path__ + "static/media/bg.a1734a4c.jpg";